<i18n src="@/i18n/backoffice/dashboard/page.json"></i18n>
<template>
	<Card :title="$t('dashboard.tickets_this_month')">
		<div class="p-4">
			<canvas ref="chart"></canvas>
		</div>
	</Card>
</template>
<script>
import Dashboard from "@/API/Dashboard.js";
import Card from "@/components/Card.vue"
import Chart from 'chart.js/auto'
export default {
	name: "CurrentMonthsSupportTicketChart",
	components: {
		Card
	},
	data() {
		return {
			chartData: null
		}
	},
	methods: {
		async renderChart() {
			const [err, res] = await Dashboard.loadChart('support-tickets:current-month')

			this.chart = new Chart(this.$refs.chart, {
				type: 'pie',
				data: res.data.data,
				tension: 0.4
			});
		}
	},
	mounted() {
		this.renderChart()
	}
}

</script>
